import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createBrandAction } from '../../../redux/actions/brandsActions';
import Button from '../../shared/buttons/Button';
import Modal from '../../shared/modal/Modal';
import BrandForm from '../forms/BrandForm';

const CreateBrandModal = ({ onModalClose, onModalSubmit }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onSubmit = async (data) => {
    setLoading(true);
    await dispatch(createBrandAction(data));
    setLoading(false);
    onModalSubmit();
  };

  return (
    <Modal
      title={'Додати марку'}
      loading={loading}
      onClose={onModalClose}
      body={<BrandForm readOnly={false} onSubmit={onSubmit} loading={loading} />}
      actionButton={
        <Button type={'submit'} disabled={loading} variant={'primary'} formId={'brand-form'} children={'Зберегти'} />
      }
    />
  );
};

export default CreateBrandModal;
